import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ParametrosService } from 'app/services/parametros.service';
import { Marca } from 'app/models/marca.models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateMarcaComponent } from './create-marca/create-marca.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.css'],
})
export class MarcasComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  dataSource = new MatTableDataSource<Marca>([]);
  loading = false;
  totalItems = 0;
  pageSize = 20;
  currentPage = 0;
  filteredData: Marca[] = [];

  constructor(
    private parametrosService: ParametrosService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Marcas';
    }
    this.getMarcas();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.updatePagination();
  }

  updatePagination() {
    this.totalItems = this.dataSource.filteredData.length;
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  getMarcas() {
    this.loading = true;
    this.parametrosService.getMarcas().subscribe(
      data => {
        this.dataSource.data = data;
        this.filteredData = data;
        this.totalItems = data.length;
        this.loading = false;
      },
      err => {
        this.loading = false;
        console.error('Error al obtener las marcas', err);
        this.openSnackBar('Error al obtener las marcas', 'Cerrar');
      }
    );
  }

  nuevaMarca() {
    let marca: Marca = new Marca();
    const dialogRef = this.dialog.open(CreateMarcaComponent, {
      disableClose: true,
      autoFocus: true,
      width: "400px",
      data: {
        name: '',
        code: '',
        type: "Nueva",
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;
      const { code, name } = data;
      marca.code = code;
      marca.name = name;
      this.parametrosService.guardarMarca(marca).subscribe(
        () => {
          this.openSnackBar("Marca creada correctamente", "Cerrar");
          this.getMarcas();
        },
        (error) => {
          console.error("Error al crear la marca", error);
          this.openSnackBar("Error al crear la marca", "Cerrar");
        }
      );
    });
  }

  editarMarca(marca: Marca) {
    const { id } = marca;
    const dialogRef = this.dialog.open(CreateMarcaComponent, {
      disableClose: true,
      autoFocus: true,
      width: '400px',
      data: {
        name: marca.name,
        code: marca.code,
        type: "Modificar",
      },
    });
    dialogRef.afterClosed().subscribe(data => {
      if (!data) return;
      const { code, name } = data;
      marca.name = name;
      marca.code = code;
      this.parametrosService.modificarMarca(marca, id).subscribe(
        () => {
          this.openSnackBar("Marca modificada correctamente", "Cerrar");
          this.getMarcas();
        },
        error => {
          console.error("Error al modificar la marca", error);
          this.openSnackBar("Error al modificar la marca", "Cerrar");
        }
      );
    });
  }

  borrarMarca(marca: Marca) {
    const { id } = marca;
    this.parametrosService.borrarMarca(id).subscribe(
      data => {
        this.openSnackBar("Marca eliminada correctamente", "Cerrar");
        this.getMarcas();
      },
      error => {
        console.error("Error al eliminar la marca", error);
        this.openSnackBar("Error al eliminar la marca", "Cerrar");
      }
    );
  }

  openSnackBar(message: string, type) {
    this.snackBar.open(message, type, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
